import SingleBlog from './SingleBlog'
export default SingleBlog